import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-table',
  standalone: true,
  templateUrl: './rt-icon-table.component.html',
  styleUrls: ['./rt-icon-table.component.scss']
})
export class RtIconTableComponent {
  @Input() width: number | string = 12;
  @Input() height: number | string = 12;
}
